export default
{
  en: {
    rootNameById: {
      profil: 'profile',
      newSetup: 'startNewAccount',
      accounts: 'Comptes',
      home: 'Home'
    },
    links: {
      newSetup: '/start-new-account',
      home: '/',
      accounts: '/accounts',
      details: '/car/{conditions}/{make}/{model}/{year}/{id}/',
      about: '/about/',
      search: '/search/',
      searchNew: '/search/new/all/all',
      searchUsed: '/search/used/all/all',
      newAccount: '/new-account/',
      newAd: '/new-ad/',
      connection: '/login/',
      seller: '/seller/',
      newBuyer: '/new-buyer/',
      profil: '/profile/',
      account: '/accounts/',
      settings: '/parametres/',
      contactUs: '/contact-us/',
      start: '/start/',
      interface: '/interface/',
      pricing: '/pricing/',
      domain: '/domain/',
      mydomain: '/fr/my-domains/',
      myEmails: '/my-emails/',
      pos: '/point-of-sale/'
    },
    sections: {
      home: {
        title: 'Home'
      },
      orders: {
        title: 'Orders'
      },
      products: {
        title: 'Products'
      },
      customers: {
        title: 'Customers'
      },
      stats: {
        title: 'Stats'
      },
      marketing: {
        title: 'Marketing'
      },
      sales: {
        title: 'Sales'
      },
      app: {
        title: 'App'
      },
      canaux: {
        title: 'Canaux'
      },
      setings: {
        title: 'Setings'
      },
      website: {
        title: 'Website'
      }
    },
    subSections: {
      orders: 'orders',
      'pre-orders': 'pre-orders',
      'abandoned-orders': 'abandoned-orders',
      'add-product': 'Add A Product',
      'all-products': 'All Products',
      stocks: 'stocks',
      'family-products': 'family-products',
      'categories-products': 'categories-products'
    },
    startForFree: 'Start For Free',
    myWebsited: 'Websites',
    startText: 'Your website online in just a few clicks with Prismyk',
    startSubText: 'A very wise choice',
    freeTry14Days: 'Free trial for 14 days',
    year: 'All Years',
    make: 'All Makes',
    model: 'All Models',
    search: 'Search',
    services: 'Services',
    newVehicles: 'New Vehicles',
    usedVehicles: 'Used Vehicles',
    about: 'About',
    homeSubtitle: 'Build your website today',
    contactUs: 'Contact Us',
    car: 'Car',
    min10Char: 'Enter at least 10 characters',
    connectToMessage: 'Veuillez vous connecter pour messager ce vendeur.',
    connectToCall: 'Veuillez vous connecter pour appeler ce vendeur.',
    askForHomeTestDrive: 'Do you offer at-home test drives?',
    askForFinancing: 'Do you offer financing?',
    askForTrade: 'Would you accept to trade this car?',
    currentGoals: 'Current Goals',
    quote: 'Inspiration',
    title: 'Title',
    business: 'Business',
    fname: 'First Name',
    lname: 'Last Name',
    name: 'Your Name',
    businessName: 'Business Name',
    activityArea: 'Activity Area',
    fbLoginText: 'Facebook',
    logout: 'Logout',
    lnLoginText: 'Linkedin',
    socialMediaLgin: 'Login With Your Account',
    orManuallyText: 'Or Sign In With your Email:',
    loginText: 'Login',
    signupText: 'Sign Up',
    forgotPasswordText: 'Forgot your password?',
    newAccountText: 'You don\'t have an account?',
    emailText: 'Email',
    passwordText: 'Password',
    newPasswordText: 'New Password',
    alreadyAccountText: 'I already have an account',
    forgotPasswordTitleText: 'Forgot your password',
    newAccountButtonText: 'Next',
    newAccountTitleText: 'New Account',
    newAccountByEmailDisclaimer: 'By clicking Next, you agree to our {0} and our {1}.',
    privacyPolicyText: 'Privacy Policy',
    loadingText: 'Loading',
    userAgreementText: 'User Agreement',
    settingsTitle: 'Settings',
    matchTitle: 'Stationne',
    chatTitle: 'Chat',
    searchTitle: 'Search',
    languageText: 'Language',
    countryText: 'Country',
    cityText: 'Ville',
    accountTypeText: 'Type de compte',
    en: 'English',
    fr: 'Français',
    enregistrer: 'Save',
    domainText: 'Areas',
    addText: 'Add',
    noMatchLogin: 'The email and password do not match.',
    pics: 'Pictures',
    featuredNewText: 'Featured New',
    featuredUsedText: 'Featured Used',
    shopByBodyType: 'SHOP BY BODY-TYPE',
    shopByMake: 'Shop By Make',
    KeyWords: 'Key-words',
    accountInformationText: 'Account Informations',
    newSellerText: 'New Seller',
    checkoutText: 'Checkout',
    createYourAdsText: 'Create Your Ads',
    chooseYourPlanText: 'Choose Your Plan',
    start: 'Start',
    bodyTypes: {
      SUV: 'SUV',
      Hatchback: 'Hatchback',
      Convertible: 'Convertible',
      Coupe: 'Coupe',
      Van: 'Van',
      Sedan: 'Sedan',
      Pickup: 'Pickup',
      Station: 'Wagon',
      Vintage: 'Vintage',
      Supercar: 'Supercar',
      Small: 'Small',
      fourByFour: '4x4'
    },
    frequencies: {
      1: 'Monthly',
      2: 'Annualy',
      3: '2 years'
    }
  },
  fr: {
    rootNameById: {
      profil: 'profil',
      newSetup: 'nouveauCompte',
      accounts: 'Comptes',
      home: 'Accueil'
    },
    links: {
      newSetup: '/commencer-nouveau-compte',
      home: '/fr/',
      accounts: '/fr/comptes',
      details: '/auto/{conditions}/{make}/{model}/{year}/{id}/',
      about: '/fr/a-propos/',
      search: '/fr/recherche/',
      searchNew: '/fr/recherche/new/all/all/',
      searchUsed: '/fr/recherche/used/all/all/',
      newAccount: '/fr/nouveau-compte/',
      newAd: '/fr/nouvelle-annonce/',
      connection: '/connexion/',
      seller: '/fr/endeur/',
      newBuyer: '/fr/nouvel-acheteur/',
      profil: '/fr/profil/',
      account: '/fr/comptes/',
      settings: '/fr/settings/',
      contactUs: '/fr/contactez-nous/',
      start: '/fr/commmencer/',
      interface: '/fr/interface/',
      pricing: '/fr/tarrication/',
      mydomain: '/fr/mes-domaines/',
      domain: '/fr/domaine/',
      myEmails: '/fr/mes-courriels/',
      pos: '/fr/point-de-vente/'
    },
    sections: {
      home: {
        title: 'Accueil'
      },
      orders: {
        title: 'Commandes'
      },
      products: {
        title: 'Produits'
      },
      customers: {
        title: 'Clients'
      },
      stats: {
        title: 'Stats'
      },
      marketing: {
        title: 'Marketing'
      },
      sales: {
        title: 'Ventes'
      },
      app: {
        title: 'App'
      },
      canaux: {
        title: 'Canaux'
      },
      setings: {
        title: 'Configurations'
      },
      website: {
        title: 'Site Web'
      }
    },
    subSections: {
      orders: 'orders',
      'pre-orders': 'pre-orders',
      'abandoned-orders': 'abandoned-orders',
      'add-product': 'add-product',
      'all-products': 'Tous les produits',
      stocks: 'stocks',
      'family-products': 'family-products',
      'categories-products': 'categories-products'
    },
    myWebsited: 'My Websites',
    startForFree: 'Commencer gratuitement',
    startText: 'Votre site Web en ligne en quelques cliques avec Prismyk',
    startSubText: 'Un choix très judicieux',
    freeTry14Days: 'Essais gratuit pendant 14 jours',
    year: 'Année',
    make: 'Fabriquant',
    model: 'Modèle',
    search: 'Recherche',
    newVehicles: 'Véhicules neufs',
    services: 'Services',
    usedVehicles: 'Véhicules d\'occasion',
    about: 'À propos',
    homeSubtitle: 'Construisez votre site web dès aujourd\'hui',
    contactUs: 'Contactez Nous',
    car: 'Voiture',
    min10Char: 'Entrez au moins 10 caractères',
    connectToMessage: 'Please connect to send message to this seller.',
    connectToCall: 'Please connect to call this seller.',
    askForHomeTestDrive: 'Proposez-vous des essais de conduite à domicile?',
    askForFinancing: 'Proposez-vous du financement?',
    askForTrade: 'Accepteriez-vous d\'échanger cette voiture?',
    currentGoals: 'Objectifs visés',
    quote: 'Inspiration',
    title: 'Titre',
    business: 'Entreprise',
    fname: 'Prénom',
    lname: 'Nom',
    name: 'Votre nom',
    businessName: "Nom de l'entrepsise",
    activityArea: 'Secteur(s) d\'activité',
    fbLoginText: 'Facebook',
    logout: 'Logout',
    lnLoginText: 'Linkedin',
    socialMediaLgin: 'Connectez-vous avec votre compte',
    orManuallyText: 'ou avec votre email:',
    loginText: 'Se connecter',
    signupText: 'S\'inscrire',
    forgotPasswordText: 'Mot de passe oublié ?',
    newAccountText: 'Vous n\'avez pas de compte ?',
    emailText: 'Email',
    passwordText: 'Mot de passe',
    newPasswordText: 'Nouveau mot de passe',
    alreadyAccountText: 'J\'ai déjà un compte',
    forgotPasswordTitleText: 'Mot de passe oublié',
    newAccountButtonText: 'Suivant',
    newAccountTitleText: 'Nouveau compte',
    newAccountByEmailDisclaimer: 'En cliquant sur suivant, vous acceptez nos {0} et nos {1}.',
    privacyPolicyText: 'politiques de confidentialité',
    loadingText: 'Chargement',
    userAgreementText: 'conditions d\'utilisation',
    settingsTitle: 'Paramètres',
    matchTitle: 'Stationne',
    chatTitle: 'Messagerie',
    searchTitle: 'Recherche',
    languageText: 'Language',
    countryText: 'Pays',
    cityText: 'Ville',
    accountTypeText: 'Type de compte',
    en: 'English',
    fr: 'Français',
    enregistrer: 'Enregistrer',
    domainText: 'Domaines',
    addText: 'Ajouter',
    noMatchLogin: 'L\'email et le mot de passe ne correspondent pas.',
    pics: 'Images',
    featuredNewText: 'Neuf en vedette',
    featuredUsedText: 'D\'occasion en vedette',
    shopByBodyType: 'Type de carrosserie',
    shopByMake: 'Par marques',
    KeyWords: 'Mots clés',
    newSellerText: 'Nouveau Vendeur',
    accountInformationText: 'Informations au compte',
    checkoutText: 'Paiement',
    createYourAdsText: 'Créez vos annonces',
    chooseYourPlanText: 'Choisissez votre plan',
    start: 'Commencer',
    bodyTypes: {
      SUV: 'VUS',
      Hatchback: 'À hayon',
      Convertible: 'Cabriolet',
      Coupe: 'Coupé',
      Van: 'Fourgonnette',
      Sedan: 'Berline',
      Pickup: 'Camionnette',
      Station: 'Familliale',
      Vintage: 'Ancienne',
      Supercar: 'Supercar',
      Small: 'Petite',
      fourByFour: '4x4'
    },
    frequencies: {
      1: 'Mensuel',
      2: 'Annuel',
      3: 'Aux 2 ans'
    }
  }
}
